export interface Iproject {
  code?: string
  id?: number
  uuid?: string
  description: string
  coordinator_id?: number
  sga_user_id?: number
  sgt_user_id?: number
  sga_responsibles?: [
    {
      id: number
    }
  ]
  sgt_responsibles?: [
    {
      id: number
    }
  ]
}

export const projectInitValues: Iproject = {
  description: '',
}
